<div>
    <div class="header-text" [ngClass]="{'text-center': center}">{{name}}</div>
</div>
